import { aboutApi } from "@/api/about";
import { defineStore } from "pinia";

export type AboutState = {
    version: string | null;
    updateCheckNeeded: boolean;
};

export const useAboutStore = defineStore("about", {
    state: (): AboutState => ({
        version: null,
        updateCheckNeeded: false,
    }),
    actions: {
        async load() {
            const aboutInfo = await aboutApi.about();
            this.version = aboutInfo.version;
        },
        requestUpdateCheck() {
            this.updateCheckNeeded = true;
        },
        clearUpdateCheck() {
            this.updateCheckNeeded = false;
        },
    },
});
